<template>
  <div>
    <section>
      <div class="about-me-container">
        <vue-showdown
          v-if="userInfo.userBio"
          :markdown="userInfo.userBio"
          tag="p"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AboutMeComponent",
  components: {
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style scoped lang="scss">
.about-me-header {
  display: flex;
}

.about-me-container {
  word-break: break-all;
  // border-bottom: 1px solid #b1b1b1;
}
</style>